import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { DatePicker } from "antd";
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import SearchSelect from "components/common/SearchSelect";
import {
    fetchEmployeeEmails
} from "api/menu/email-blaster/actions";
import {
    fetchMerchandiserInvoicingJobs,
} from "api/menu/invoicing/actions";
import counterEmailFilter from "components/menu/email-blaster/counter-email-filter";
import counterEmailList from "components/menu/email-blaster/counter-email-types";
import EmailTable from "components/menu/email-blaster/email-table";

class FromServices extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            selectedType: null,
            dateFrom: null,
            dateTo: null,
            jobId: null,
            counterEmail: 0,
            selectedUsers: [],
        };

        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.handleSelectUserEmails = this.handleSelectUserEmails.bind(this);
        this.handleLoad = this.handleLoad.bind(this);
        this.getSelectedUsersEmail = this.getSelectedUsersEmail.bind(this);

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });

        this.props.fetchMerchandiserInvoicingJobs();
    }

    handleChangeDate = (name, date) => {
        this.setState({
            [name]: date
        });
    };

    handleSelect = (name, option) => {
        this.setState({
            [name]: option
        });
    };

    handleRadio = (ev) => {
        const {
            name,
            value
        } = ev.target;
        this.setState({
            [name]: parseInt(value, 10)
        });
    };

    handleLoad = () => {
        const {
            jobId,
            dateFrom,
            dateTo
        } = this.state;

        if (this.validator.allValid()) {
            this.props.fetchEmployeeEmails(
                jobId.value,
                moment(dateFrom).format("YYYY-MM-DD"),
                moment(dateTo).format("YYYY-MM-DD")
            );
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    handleSelectUserEmails = (email) => {
        let selectedUsers = Object.assign([], this.state.selectedUsers);
        if (email === false) {
            if (selectedUsers.length) {
                selectedUsers = [];
            } else {
                selectedUsers = counterEmailFilter(
                    this.props.employeeEmails,
                    this.state.counterEmail
                ).map(value => value.email);
            }
        } else {
            const index = selectedUsers.indexOf(email);
            if (index > -1) {
                selectedUsers.splice(index, 1);
            } else {
                selectedUsers.push(email);
            }
        }

        this.setState({
            selectedUsers
        });
    };

    getSelectedUsersEmail = () => {
        const usersEmails = Object.assign([], this.state.selectedUsers);
        this.setState({
            selectedUsers: []
        });
        return usersEmails;
    };

    render() {
        const {
            jobs,
            employeeEmails
        } = this.props;

        const jobsOptions = jobs.map(job => ({
            value: job.id,
            label: `${job.jobNumber} - ${job.description}`
        }));

        const {
            dateFrom,
            dateTo,
            jobId,
            counterEmail,
            selectedUsers,
        } = this.state;

        const users = counterEmailFilter(employeeEmails, counterEmail);

        return (
            <div className="pt-2 pb-2">
                <div className="input-group mb-3">
                    <div className="input-group-prepend w-25">
                        <span className="input-group-text justify-content-end w-100">From:</span>
                    </div>
                    <DatePicker
                        value={dateFrom}
                        format={this.dateFormat}
                        onChange={date => this.handleChangeDate("dateFrom", date)}
                        className="d-block w-75"
                    />
                    {this.validator.message("dateFrom", dateFrom, "required")}
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend w-25">
                        <span className="input-group-text justify-content-end w-100">To:</span>
                    </div>
                    <DatePicker
                        value={dateTo}
                        format={this.dateFormat}
                        onChange={date => this.handleChangeDate("dateTo", date)}
                        className="d-block w-75"
                    />
                    {this.validator.message("dateTo", dateFrom, "required")}
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-prepend w-25">
                        <span className="input-group-text justify-content-end w-100">Job:</span>
                    </div>
                    <SearchSelect
                        options={jobsOptions}
                        isLoading={false}
                        isClearable={true}
                        isSearchable={true}
                        value={jobId}
                        onChange={(option) => this.handleSelect("jobId", option)}
                        className="w-75"
                    />
                    {this.validator.message("jobId", jobId, "required")}
                </div>
                <div className="d-flex justify-content-between mb-3">
                    <div className="d-inline-flex align-items-center">
                        <label className="mb-0">
                            Counter Email?
                        </label>
                        <div className="ml-2">
                            {counterEmailList.map(perRadio => (
                                <div className="form-check-inline" key={perRadio.value}>
                                    <label className="form-check-label">
                                        <input
                                            type="radio"
                                            className="form-check-input"
                                            name="counterEmail"
                                            value={perRadio.value}
                                            onChange={this.handleRadio}
                                            checked={counterEmail === perRadio.value}
                                        /> {perRadio.title}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="text-right">
                        <button
                            className="btn btn-primary"
                            onClick={this.handleLoad}
                        >
                            Load
                        </button>
                    </div>
                </div>

                <EmailTable
                    height={296}
                    users={users}
                    selectedUsers={selectedUsers}
                    onSelectUserEmails={this.handleSelectUserEmails}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    jobs: state.invoicing.jobs,
    employeeEmails: state.emailBlaster.employeeEmails
});

const mapStateToDispatch = dispatch => ({
    fetchEmployeeEmails: bindActionCreators(fetchEmployeeEmails, dispatch),
    fetchMerchandiserInvoicingJobs: bindActionCreators(fetchMerchandiserInvoicingJobs, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch,
    null,
    { withRef: true }
)(FromServices);
